import { Link } from "react-router-dom";
import { POLICY_CONTENT } from "../data/policyContent";
import { useSEO } from "../lib/seo";

export default function PolicyPage({ slug }) {
  const policy = POLICY_CONTENT[slug];

  useSEO({
    title: `${policy?.title || "Policy"} — GenieX`,
    description: `GenieX ${policy?.title || "policy"} — how we work, ship and support your smart home purchase.`,
    path: `/${slug}`,
  });

  if (!policy) return null;

  return (
    <main data-testid={`policy-page-${slug}`} className="bg-[var(--gx-bg)] text-white pt-28 lg:pt-36 pb-24 min-h-screen">
      <div className="max-w-[760px] mx-auto px-5 lg:px-0">
        <p className="eyebrow mb-3">Legal</p>
        <h1 className="h2-display mb-2" data-testid="policy-page-title">
          {policy.title}
        </h1>
        <p className="text-mute text-[12px] tracking-wide mb-10" data-testid="policy-page-updated">
          Last updated {policy.updated}
        </p>

        <div className="space-y-9">
          {policy.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-display text-lg text-gold mb-3">{s.heading}</h2>
              <div className="space-y-2.5">
                {s.body.map((p, i) => (
                  <p key={i} className="text-dim text-sm leading-relaxed">
                    {p}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-line flex flex-wrap gap-x-5 gap-y-2 text-[12.5px]">
          {Object.entries(POLICY_CONTENT)
            .filter(([s]) => s !== slug)
            .map(([s, p]) => (
              <Link key={s} to={`/${s}`} className="text-dim hover:text-gold transition-colors" data-testid={`policy-link-${s}`}>
                {p.title}
              </Link>
            ))}
        </div>
      </div>
    </main>
  );
}
